import React, { useState, useEffect } from 'react';
import './styles/Banner.css';
import QuoteForm from './QuoteForm';
import moversBanner from '../assets/movers-banner.png';

const captions = [
  "Reliable Moving Services at Your Fingertips",
  "Safe and Hassle-Free Relocation",
  "Affordable Prices with Professional Touch"
];

const Banner = () => {
  const [currentCaptionIndex, setCurrentCaptionIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentCaptionIndex((prevIndex) => (prevIndex + 1) % captions.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="banner-container">
      <div className="banner-content">
        <div className="banner-left">
          <div className="banner-image">
            <img
              src={moversBanner}
              alt="Moving services banner"
              className="banner-img"
            />
          </div>
          <h1 className="banner-title">Pet Moving Made Easy</h1>
          <h2 className="banner-caption">{captions[currentCaptionIndex]}</h2>
          <p className="banner-main-caption">
            We move with care and compassion. Get started with your pet’s journey today!
          </p>
        </div>
        <div className="banner-right">
          <QuoteForm />
        </div>
      </div>
    </div>
  );
};

export default Banner;
